/* eslint-disable max-len */
import React, { PureComponent } from 'react';

const FOP_QUICK_MENU_ICON_STYLE = { width: '33px', height: '32px', strokeWidth: 0, fill: 'transparent' };

export default class FopQuickMenuIcon extends PureComponent {
  render() {
    const outline = 'M27.5,0.6c-1-0.4-2.1-0.6-3.2-0.6h0C23.2,0,22,0.2,21,0.7C20,0.2,18.8,0,17.7,0c-1.1,0-2.1,0.2-3.1,0.6' +
                    'C11.2,2,9,5.2,9,8.8c0,0.5,0,1,0.1,1.5l0,0l0,0c0.2,0.9,0.5,1.8,0.9,2.7H0v17h23v-7.2l0.2-0.2l1.1-1.2c0.3-0.3,3.3-3.3,5.7-5.7' +
                    'c1.5-1.4,2.5-3.3,2.9-5.4l0,0l0,0C33,9.8,33,9.3,33,8.8C33,5.2,30.8,2,27.5,0.6z';

    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <rect className="hover-trigger" style={FOP_QUICK_MENU_ICON_STYLE} />
        <g className="fav-anim">
          <g>
            <path
              className="outline"
              d={outline}
            />
          </g>
          <g>
            <path className="heart-line" d="M27.6,4.7C25.4,3.3,22.7,4.2,21,6c-1.7-1.8-4.4-2.7-6.6-1.3C13,5.6,12,7,12,9.4c0,0.3,0,0.7,0.1,1  c0.2,1.3,0.9,2.6,2,3.8c2.2,2.2,6.9,7,6.9,7s4.7-4.8,6.9-7c1.1-1.1,1.8-2.4,2-3.8c0-0.3,0.1-0.7,0.1-1C30,7,29,5.6,27.6,4.7z" />
            <polygon className="lines" points="14 18 11 15 7 15 7 18 14 18" />
            <polygon className="lines" points="19 23 16 20 7 20 7 23 19 23" />
            <rect className="lines" x="2" y="15" width="3" height="3" />
            <rect className="lines" x="2" y="20" width="3" height="3" />
          </g>
          <g className="line-out">
            <rect className="lines" x="7" y="25" width="14" height="3" />
            <rect className="lines" x="2" y="25" width="3" height="3" />
          </g>
          <g className="line-in">
            <rect className="lines" x="7" y="25" width="14" height="3" />
            <rect className="lines" x="2" y="25" width="3" height="3" />
          </g>
          <path className="heart" d="M25.2,7c0.3,0,0.5,0.1,0.7,0.2c0.5,0.3,1,0.8,1,2.2c0,0.2,0,0.4,0,0.6c-0.1,0.7-0.5,1.4-1.2,2.1  c-1.2,1.2-3.3,3.3-4.8,4.8c-1.5-1.6-3.6-3.6-4.8-4.8c-0.7-0.7-1.1-1.4-1.2-2.1c0-0.2,0-0.4,0-0.5c0-1.4,0.5-1.9,1-2.2  C16.3,7.1,16.5,7,16.8,7c0.7,0,1.5,0.4,2.1,1l2.2,2.2L23.2,8C23.8,7.4,24.6,7,25.2,7" />
        </g>
      </svg>
    );
  }
}
